import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addEmailListTarget, getEmailListTarget, updateEmailListTarget, deleteEmailListTarget} from "../../store/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class EmailListTarget extends Component {
    constructor(props) {
        super(props)
        this.state = {
            emaillisttarget: ''
        }
        this.handleProTypeSubmit = this.handleProTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (emaillisttarget) => {
        this.setState({ emaillisttarget: emaillisttarget });
        this.setState({ deleteModal: true });
    };

    handleDeleteProType = () => {
        const { onDeleteProType } = this.props;
        const { emaillisttarget } = this.state;

        if (emaillisttarget.id !== undefined) {
            onDeleteProType(emaillisttarget);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleProTypeSubmit(value) {
      
        this.props.addEmailListTarget(value);
    }

    componentDidMount() {
        const { onGetEmailListTarget } = this.props;
        onGetEmailListTarget(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { emaillisttargets } = this.props;
        if (!isEmpty(emaillisttargets) && size(prevProps.emaillisttargets) !== size(emaillisttargets)) {
            this.setState({ emaillisttargets: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ emaillisttarget: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const emaillisttarget = arg;
        this.setState({
            emaillisttarget: {
                id: emaillisttarget.id,
                emailListTargetId: emaillisttarget.emailListTargetId,
                agentId: emaillisttarget.agentId,
                emailListTargetTitle: emaillisttarget.emailListTargetTitle,
                isActive:emaillisttarget.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { emaillisttargets, onUpdateEmailListTarget } = this.props;
        const { isEdit, deleteModal } = this.state;
        const emaillisttarget = this.state.emaillisttarget;
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteProType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Email List Target | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Email List Target")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        emailListTargetTitle: (this.state && this.state.emailListTargetTitle) || "",
                                        agentId:parseInt(localStorage.getItem('userId'))

                                    }}
                                    validationSchema={Yup.object().shape({
                                        emailListTargetTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleProTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="emailListTargetTitle">
                                                                    {this.props.t("Title")}
                                                                </Label>
                                                                <SafeField
                                                                    name="emailListTargetTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.emailListTargetTitle && touched.emailListTargetTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="emailListTargetTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="emailListTargetTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">Email List Type History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(emaillisttargets, (emaillisttarget, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{emaillisttarget.emailListTargetTitle}</td>
                                                                        <td>
                                                                            <ActionEdit onClick={() => this.toggleRightCanvas(emaillisttarget)} />
                                                                            <ActionDelete onClick={() => this.onClickDelete(emaillisttarget)} /> 
                                                                           

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: emaillisttarget.id,
                                        emailListTargetId: emaillisttarget.emailListTargetId,
                                        emailListTargetTitle: emaillisttarget.emailListTargetTitle,
                                        agentId: emaillisttarget.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        emailListTargetTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                emailListTargetId: values.emailListTargetId,
                                                emailListTargetTitle: values.emailListTargetTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateEmailListTarget(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="emailListTargetTitle">
                                                            {this.props.t("Title")}
                                                        </Label>
                                                        <SafeField
                                                            name="emailListTargetTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.emailListTargetTitle && touched.emailListTargetTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="emailListTargetTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="emailListTargetTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
EmailListTarget.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addEmailListTarget: PropTypes.func,
    onGetEmailListTarget: PropTypes.func,
    emaillisttargets: PropTypes.array,
    onDeleteProType: PropTypes.func,
    onUpdateEmailListTarget: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        emaillisttargets: AppoinmentObject.emaillisttargets,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addEmailListTarget: (data) => dispatch(addEmailListTarget(data)),
    onGetEmailListTarget: (agentId) => dispatch(getEmailListTarget(agentId)),
    onDeleteProType: (id) => dispatch(deleteEmailListTarget(id)),
    onUpdateEmailListTarget: (data) => dispatch(updateEmailListTarget(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailListTarget))
